import React from "react";
import SahraUsersTable from "../../Tables/SahraUsers/SahraUsersTable";
import AddIcon from "@mui/icons-material/Add";
// Common Components
import { Modal } from "src/Components";
// Local Components
import AddOrEditSahraUser from "src/Forms/AddOrEditSahraUser";

const SahraUsers = () => {
  const [isAddOpen, setIsAddOpen] = React.useState(false);
  const [refresh, setRefresh] = React.useState(false);

  return (
    <div className="w-full">
      {isAddOpen ? (
        <Modal
          UI={
            <AddOrEditSahraUser
              onClose={() => {
                setIsAddOpen(false);
                setRefresh(true);
              }}
            />
          }
          onClose={() => setIsAddOpen(false)}
          modalBoxClassName="!min-w-[300px]"
        />
      ) : (
        <></>
      )}
      <div className="w-fit flex items-center mb-2 mt-5 mr-auto ml-5 gap-3">
        <div
          className="bg-sky-600 rounded-full flex justify-center items-center w-11 h-11 cursor-pointer"
          onClick={() => setIsAddOpen(true)}
        >
          <AddIcon className="text-white" />
        </div>
      </div>
      <div className="mx-auto">
        <SahraUsersTable refresh={refresh} />
      </div>
    </div>
  );
};

export default SahraUsers;
